import setPropTypes from 'recompose/setPropTypes';
import PropTypes from 'prop-types';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import React from 'react';
import { reduxForm } from 'redux-form';

import { trimFunction } from '../trimData';
import { syncValidateData } from '../validator';
import { customer as customerSchema } from '../validation/schemas';
import Input from '../input';
import CountryCodePhoneInputRedux from '../countryCodePhoneInputRedux';

const Form = ({ handleSubmit, submitButtonText }) => (
  <form onSubmit={handleSubmit}>
    <fieldset>
      <Input className="c-input c-input--white u-mb fs-mask" placeholder="First name" name="firstName" />
      <Input className="c-input c-input--white u-mb fs-mask" placeholder="Last name" name="lastName" />
      <CountryCodePhoneInputRedux className="c-input c-input--white u-mb fs-mask" placeholder="Phone" name="phone" />
      <Input className="c-input c-input--white u-mb fs-mask" placeholder="Email" name="email" />
      <div className="u-text-right">
        <button className="c-btn" type="submit">
          {submitButtonText}
        </button>
      </div>
    </fieldset>
  </form>
);
Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string,
};
Form.defaultProps = {
  submitButtonText: 'submit',
};

const CUSTOMER_FORM = 'CUSTOMER_FORM';

const validate = values => syncValidateData(values, customerSchema);
const CustomerForm = compose(
  setPropTypes({
    onSubmit: PropTypes.func.isRequired,
  }),
  withHandlers({
    onSubmit: props => trimFunction(props.onSubmit),
  }),
  reduxForm({
    form: CUSTOMER_FORM,
    validate,
  }),
)(Form);

export default CustomerForm;
